module.exports = __webpack_public_path__ + "static/media/down.c386c1ea.png";